module.exports = __webpack_public_path__ + "img/activeby.2d0452d9.png";